// src/constants/formOptions.ts
import { 
  SourceOfFunds, 
  AssetAmount as TotalAssets, // Importar con alias para mantener compatibilidad
  MonthlyInvestmentAmount as MonthlyAmount, // Importar con alias para mantener compatibilidad 
  DepositWithdrawalCount
} from '../types/financial.types';
import { engageInActivities, VendorsCounterparties } from '../types/kyc.types';
import { DocumentType } from '../types/documents.types';

export const COUNTRIES = [
    { code: 'AF', name: 'Afghanistan' },
    { code: 'AX', name: 'Aland Islands' },
    { code: 'AL', name: 'Albania' },
    { code: 'DZ', name: 'Algeria' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AD', name: 'Andorra' },
    { code: 'AO', name: 'Angola' },
    { code: 'AI', name: 'Anguilla' },
    { code: 'AQ', name: 'Antarctica' },
    { code: 'AG', name: 'Antigua and Barbuda' },
    { code: 'AR', name: 'Argentina' },
    { code: 'AM', name: 'Armenia' },
    { code: 'AW', name: 'Aruba' },
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'AZ', name: 'Azerbaijan' },
    { code: 'BS', name: 'Bahamas' },
    { code: 'BH', name: 'Bahrain' },
    { code: 'BD', name: 'Bangladesh' },
    { code: 'BB', name: 'Barbados' },
    { code: 'BY', name: 'Belarus' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BZ', name: 'Belize' },
    { code: 'BJ', name: 'Benin' },
    { code: 'BM', name: 'Bermuda' },
    { code: 'BT', name: 'Bhutan' },
    { code: 'BO', name: 'Bolivia' },
    { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', name: 'Bosnia and Herzegovina' },
    { code: 'BW', name: 'Botswana' },
    { code: 'BV', name: 'Bouvet Island' },
    { code: 'BR', name: 'Brazil' },
    { code: 'IO', name: 'British Indian Ocean Territory' },
    { code: 'BN', name: 'Brunei Darussalam' },
    { code: 'BG', name: 'Bulgaria' },
    { code: 'BF', name: 'Burkina Faso' },
    { code: 'BI', name: 'Burundi' },
    { code: 'KH', name: 'Cambodia' },
    { code: 'CM', name: 'Cameroon' },
    { code: 'CA', name: 'Canada' },
    { code: 'CV', name: 'Cape Verde' },
    { code: 'KY', name: 'Cayman Islands' },
    { code: 'CF', name: 'Central African Republic' },
    { code: 'TD', name: 'Chad' },
    { code: 'CL', name: 'Chile' },
    { code: 'CN', name: 'China' },
    { code: 'CX', name: 'Christmas Island' },
    { code: 'CC', name: 'Cocos (Keeling) Islands' },
    { code: 'CO', name: 'Colombia' },
    { code: 'KM', name: 'Comoros' },
    { code: 'CG', name: 'Congo' },
    { code: 'CD', name: 'Congo, Democratic Republic of the' },
    { code: 'CK', name: 'Cook Islands' },
    { code: 'CR', name: 'Costa Rica' },
    { code: 'CI', name: "Cote d'Ivoire" },
    { code: 'HR', name: 'Croatia' },
    { code: 'CU', name: 'Cuba' },
    { code: 'CW', name: 'Curacao' },
    { code: 'CY', name: 'Cyprus' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'DK', name: 'Denmark' },
    { code: 'DJ', name: 'Djibouti' },
    { code: 'DM', name: 'Dominica' },
    { code: 'DO', name: 'Dominican Republic' },
    { code: 'EC', name: 'Ecuador' },
    { code: 'EG', name: 'Egypt' },
    { code: 'SV', name: 'El Salvador' },
    { code: 'GQ', name: 'Equatorial Guinea' },
    { code: 'ER', name: 'Eritrea' },
    { code: 'EE', name: 'Estonia' },
    { code: 'ET', name: 'Ethiopia' },
    { code: 'FK', name: 'Falkland Islands (Malvinas)' },
    { code: 'FO', name: 'Faroe Islands' },
    { code: 'FJ', name: 'Fiji' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'GF', name: 'French Guiana' },
    { code: 'PF', name: 'French Polynesia' },
    { code: 'TF', name: 'French Southern Territories' },
    { code: 'GA', name: 'Gabon' },
    { code: 'GM', name: 'Gambia' },
    { code: 'GE', name: 'Georgia' },
    { code: 'DE', name: 'Germany' },
    { code: 'GH', name: 'Ghana' },
    { code: 'GI', name: 'Gibraltar' },
    { code: 'GR', name: 'Greece' },
    { code: 'GL', name: 'Greenland' },
    { code: 'GD', name: 'Grenada' },
    { code: 'GP', name: 'Guadeloupe' },
    { code: 'GU', name: 'Guam' },
    { code: 'GT', name: 'Guatemala' },
    { code: 'GG', name: 'Guernsey' },
    { code: 'GN', name: 'Guinea' },
    { code: 'GW', name: 'Guinea-Bissau' },
    { code: 'GY', name: 'Guyana' },
    { code: 'HT', name: 'Haiti' },
    { code: 'HM', name: 'Heard Island and McDonald Islands' },
    { code: 'VA', name: 'Holy See (Vatican City State)' },
    { code: 'HN', name: 'Honduras' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'HU', name: 'Hungary' },
    { code: 'IS', name: 'Iceland' },
    { code: 'IN', name: 'India' },
    { code: 'ID', name: 'Indonesia' },
    { code: 'IR', name: 'Iran, Islamic Republic of' },
    { code: 'IQ', name: 'Iraq' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IM', name: 'Isle of Man' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JM', name: 'Jamaica' },
    { code: 'JP', name: 'Japan' },
    { code: 'JE', name: 'Jersey' },
    { code: 'JO', name: 'Jordan' },
    { code: 'KZ', name: 'Kazakhstan' },
    { code: 'KE', name: 'Kenya' },
    { code: 'KI', name: 'Kiribati' },
    { code: 'KP', name: "Korea, Democratic People's Republic of" },
    { code: 'KR', name: 'Korea, Republic of' },
    { code: 'KW', name: 'Kuwait' },
    { code: 'KG', name: 'Kyrgyzstan' },
    { code: 'LA', name: "Lao People's Democratic Republic" },
    { code: 'LV', name: 'Latvia' },
    { code: 'LB', name: 'Lebanon' },
    { code: 'LS', name: 'Lesotho' },
    { code: 'LR', name: 'Liberia' },
    { code: 'LY', name: 'Libya' },
    { code: 'LI', name: 'Liechtenstein' },
    { code: 'LT', name: 'Lithuania' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MO', name: 'Macao' },
    { code: 'MK', name: 'Macedonia, the Former Yugoslav Republic of' },
    { code: 'MG', name: 'Madagascar' },
    { code: 'MW', name: 'Malawi' },
    { code: 'MY', name: 'Malaysia' },
    { code: 'MV', name: 'Maldives' },
    { code: 'ML', name: 'Mali' },
    { code: 'MT', name: 'Malta' },
    { code: 'MH', name: 'Marshall Islands' },
    { code: 'MQ', name: 'Martinique' },
    { code: 'MR', name: 'Mauritania' },
    { code: 'MU', name: 'Mauritius' },
    { code: 'YT', name: 'Mayotte' },
    { code: 'MX', name: 'Mexico' },
    { code: 'FM', name: 'Micronesia, Federated States of' },
    { code: 'MD', name: 'Moldova, Republic of' },
    { code: 'MC', name: 'Monaco' },
    { code: 'MN', name: 'Mongolia' },
    { code: 'ME', name: 'Montenegro' },
    { code: 'MS', name: 'Montserrat' },
    { code: 'MA', name: 'Morocco' },
    { code: 'MZ', name: 'Mozambique' },
    { code: 'MM', name: 'Myanmar' },
    { code: 'NA', name: 'Namibia' },
    { code: 'NR', name: 'Nauru' },
    { code: 'NP', name: 'Nepal' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NC', name: 'New Caledonia' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NI', name: 'Nicaragua' },
    { code: 'NE', name: 'Niger' },
    { code: 'NG', name: 'Nigeria' },
    { code: 'NU', name: 'Niue' },
    { code: 'NF', name: 'Norfolk Island' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'NO', name: 'Norway' },
    { code: 'OM', name: 'Oman' },
    { code: 'PK', name: 'Pakistan' },
    { code: 'PW', name: 'Palau' },
    { code: 'PS', name: 'Palestine, State of' },
    { code: 'PA', name: 'Panama' },
    { code: 'PG', name: 'Papua New Guinea' },
    { code: 'PY', name: 'Paraguay' },
    { code: 'PE', name: 'Peru' },
    { code: 'PH', name: 'Philippines' },
    { code: 'PN', name: 'Pitcairn' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'QA', name: 'Qatar' },
    { code: 'RE', name: 'Reunion' },
    { code: 'RO', name: 'Romania' },
    { code: 'RU', name: 'Russian Federation' },
    { code: 'RW', name: 'Rwanda' },
    { code: 'BL', name: 'Saint Barthelemy' },
    { code: 'SH', name: 'Saint Helena' },
    { code: 'KN', name: 'Saint Kitts and Nevis' },
    { code: 'LC', name: 'Saint Lucia' },
    { code: 'MF', name: 'Saint Martin (French part)' },
    { code: 'PM', name: 'Saint Pierre and Miquelon' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines' },
    { code: 'WS', name: 'Samoa' },
    { code: 'SM', name: 'San Marino' },
    { code: 'ST', name: 'Sao Tome and Principe' },
    { code: 'SA', name: 'Saudi Arabia' },
    { code: 'SN', name: 'Senegal' },
    { code: 'RS', name: 'Serbia' },
    { code: 'SC', name: 'Seychelles' },
    { code: 'SL', name: 'Sierra Leone' },
    { code: 'SG', name: 'Singapore' },
    { code: 'SX', name: 'Sint Maarten (Dutch part)' },
    { code: 'SK', name: 'Slovakia' },
    { code: 'SI', name: 'Slovenia' },
    { code: 'SB', name: 'Solomon Islands' },
    { code: 'SO', name: 'Somalia' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
    { code: 'SS', name: 'South Sudan' },
    { code: 'ES', name: 'Spain' },
    { code: 'LK', name: 'Sri Lanka' },
    { code: 'SD', name: 'Sudan' },
    { code: 'SR', name: 'Suriname' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen' },
    { code: 'SZ', name: 'Swaziland' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'SY', name: 'Syrian Arab Republic' },
    { code: 'TW', name: 'Taiwan' },
    { code: 'TJ', name: 'Tajikistan' },
    { code: 'TZ', name: 'Tanzania, United Republic of' },
    { code: 'TH', name: 'Thailand' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'TG', name: 'Togo' },
    { code: 'TK', name: 'Tokelau' },
    { code: 'TO', name: 'Tonga' },
    { code: 'TT', name: 'Trinidad and Tobago' },
    { code: 'TN', name: 'Tunisia' },
    { code: 'TR', name: 'Turkey' },
    { code: 'TM', name: 'Turkmenistan' },
    { code: 'TC', name: 'Turks and Caicos Islands' },
    { code: 'TV', name: 'Tuvalu' },
    { code: 'UG', name: 'Uganda' },
    { code: 'UA', name: 'Ukraine' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UY', name: 'Uruguay' },
    { code: 'UZ', name: 'Uzbekistan' },
    { code: 'VU', name: 'Vanuatu' },
    { code: 'VE', name: 'Venezuela' },
    { code: 'VN', name: 'Viet Nam' },
    { code: 'VG', name: 'Virgin Islands, British' },
    { code: 'VI', name: 'Virgin Islands, U.S.' },
    { code: 'WF', name: 'Wallis and Futuna' },
    { code: 'EH', name: 'Western Sahara' },
    { code: 'YE', name: 'Yemen' },
    { code: 'ZM', name: 'Zambia' },
    { code: 'ZW', name: 'Zimbabwe' }
    ] as const;

export const EMPLOYMENT_TYPES = [
 { value: 'EMPLOYEE', label: 'Employee' },
 { value: 'SELF_EMPLOYED', label: 'Self Employed' },
 { value: 'RETIRED', label: 'Retired' },
 { value: 'UNEMPLOYED', label: 'Unemployed' },
 { value: 'STUDENT', label: 'Student' },
 { value: 'OTHER', label: 'Other' }
] as const;

export const DEPOSIT_WITHDRAWAL_COUNTS = [
  { value: DepositWithdrawalCount.UPTO_5, label: 'Up to 5' },
  { value: DepositWithdrawalCount.FIVE_TO_10, label: '5 to 10' },
  { value: DepositWithdrawalCount.TEN_TO_25, label: '10 to 25' },
  { value: DepositWithdrawalCount.MORE_THAN_25, label: 'More than 25' }
];

export const SOURCE_OF_FUNDS = [
  { value: SourceOfFunds.EMPLOYMENT, label: 'Employment' },
  { value: SourceOfFunds.SAVINGS, label: 'Savings' },
  { value: SourceOfFunds.WINNINGS, label: 'Winnings' },
  { value: SourceOfFunds.MARITAL, label: 'Marital Assets' },
  { value: SourceOfFunds.REAL_ESTATE, label: 'Real Estate' },
  { value: SourceOfFunds.TRUST, label: 'Trust' },
  { value: SourceOfFunds.INVESTMENT, label: 'Investment' },
  { value: SourceOfFunds.OTHER, label: 'Other' },
  { value: SourceOfFunds.COMPANY, label: 'Company' },
  { value: SourceOfFunds.COMPANY_CAPITAL, label: 'Company Capital' },
  { value: SourceOfFunds.LOAN, label: 'Loan' },
  { value: SourceOfFunds.PRIVATE_CAPITAL, label: 'Private Capital' },
  { value: SourceOfFunds.GRANT, label: 'Grant' }
];

export const TOTAL_ASSETS = [
  { value: TotalAssets.UPTO_10K, label: 'Up to 10,000 USD' },
  { value: TotalAssets.TEN_TO_100K, label: '10,000 to 100,000 USD' },
  { value: TotalAssets.ONEHUNDREDK_TO_1M, label: '100,000 to 1,000,000 USD' },
  { value: TotalAssets.ONE_TO_10M, label: '1,000,000 to 10,000,000 USD' },
  { value: TotalAssets.TEN_TO_50M, label: '10,000,000 to 50,000,000 USD' },
  { value: TotalAssets.FIFTY_TO_250M, label: '50,000,000 to 250,000,000 USD' },
  { value: TotalAssets.MORE_THAN_250M, label: 'More than 250,000,000 USD' }
];

export const MONTHLY_AMOUNTS = [
  { value: MonthlyAmount.UPTO_1K, label: 'Up to 1,000 USD' },
  { value: MonthlyAmount.ONE_TO_100K, label: '1,000 to 100,000 USD' },
  { value: MonthlyAmount.ONEHUNDREDK_TO_1M, label: '100,000 to 1,000,000 USD' },
  { value: MonthlyAmount.MILLION_TO_5M, label: '1,000,000 to 5,000,000 USD' },
  { value: MonthlyAmount.MORE_THAN_5M, label: 'More than 5,000,000 USD' }
];

export const ENGAGE_ACTIVITIES = [
  { value: engageInActivities.NONE, label: 'None' },
  { value: engageInActivities.ADULT_ENTERTAINMENT, label: 'Adult Entertainment' },
  { value: engageInActivities.DRUGS, label: 'Drugs' },
  { value: engageInActivities.FIREARMS, label: 'Firearms' },
  { value: engageInActivities.GAMBLING, label: 'Gambling' },
  { value: engageInActivities.MARIJUANA, label: 'Marijuana' },
  { value: engageInActivities.TUMBLING, label: 'Tumbling' }
] as const;

export const VENDORS_COUNTERPARTIES = [
  { value: VendorsCounterparties.SELF, label: 'Self' },
  { value: VendorsCounterparties.MERCHANTS_SUPPLIERS, label: 'Merchants/Suppliers' },
  { value: VendorsCounterparties.CUSTOMERS, label: 'Customers' },
  { value: VendorsCounterparties.EMPLOYEES, label: 'Employees' },
  { value: VendorsCounterparties.CONTRACTORS, label: 'Contractors' },
  { value: VendorsCounterparties.FRIENDS, label: 'Friends' },
  { value: VendorsCounterparties.FAMILY, label: 'Family' }
] as const;

export const DOCUMENT_TYPES = [
  { 
    value: DocumentType.PASSPORT_FRONT, 
    label: 'ID Card (Front)', 
    description: 'Front side of your country ID Card',
    acceptedFormats: '.jpg, .jpeg, .png, .pdf',
    maxSize: 5, // En MB
    requiredResolution: '1000x1000 pixels minimum'
  },
  { 
    value: DocumentType.PASSPORT_BACK, 
    label: 'ID Card (Back)', 
    description: 'Back side of your country ID Card',
    acceptedFormats: '.jpg, .jpeg, .png, .pdf',
    maxSize: 5,
    requiredResolution: '1000x1000 pixels minimum'
  },
  { 
    value: DocumentType.UTILITY_BILL, 
    label: 'Utility Bill', 
    description: 'Recent utility bill (not older than 3 months)',
    acceptedFormats: '.jpg, .jpeg, .png, .pdf',
    maxSize: 5,
    requiredResolution: '1000x1000 pixels minimum'
  },
  { 
    value: DocumentType.BANK_STATEMENT, 
    label: 'Bank Statement', 
    description: 'Recent bank statement (not older than 3 months)',
    acceptedFormats: '.jpg, .jpeg, .png, .pdf',
    maxSize: 5,
    requiredResolution: '1000x1000 pixels minimum'
  },
  { 
    value: DocumentType.SELFIE, 
    label: 'Selfie with ID Card', 
    description: 'A photo of yourself holding your ID Card',
    acceptedFormats: '.jpg, .jpeg, .png',
    maxSize: 5,
    requiredResolution: '1000x1000 pixels minimum'
  }
] as const;

export const ACCEPTED_FILE_TYPES = '.jpg,.jpeg,.png,.pdf';
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB en bytes

export const FILE_VALIDATION_MESSAGES = {
  invalidType: 'Invalid file type. Please upload a JPG, JPEG, PNG or PDF file.',
  tooLarge: 'File is too large. Maximum size is 5MB.',
  required: 'This document is required.',
  uploadError: 'Error uploading file. Please try again.',
  deleteError: 'Error deleting file. Please try again.',
  uploadSuccess: 'Document uploaded successfully.',
  deleteSuccess: 'Document deleted successfully.',
  allRequired: 'All documents must be uploaded to continue.'
} as const;

export type CountryCode = typeof COUNTRIES[number]['code'];
export type EmploymentType = typeof EMPLOYMENT_TYPES[number]['value'];